import React from "react";
import { ToastContainer } from "react-toastify";
import AddProduct from "../../components/ProductManager/Product/AddProduct";

export const AddProductPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddProduct />
        </div>
      </div>
    </div>
  );
};
